import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cajr_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const getReviews = () => axios.get(`${API}/reviews`).then((r) => r.data);
export const createReview = (data) => axios.post(`${API}/reviews`, data).then((r) => r.data);
export const getStats = () => axios.get(`${API}/stats`).then((r) => r.data);

// Auth
export const exchangeSession = (session_id) =>
  axios.post(`${API}/auth/session`, { session_id }).then((r) => r.data);
export const fetchMe = () => axios.get(`${API}/auth/me`, { headers: authHeaders() }).then((r) => r.data);
export const logout = () => axios.post(`${API}/auth/logout`, {}, { headers: authHeaders() }).finally(clearToken);

// Admin
export const adminGetBookings = () => axios.get(`${API}/admin/bookings`, { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteBooking = (id) => axios.delete(`${API}/admin/bookings/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteReview = (id) => axios.delete(`${API}/admin/reviews/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const adminGetBlackouts = () => axios.get(`${API}/admin/blackouts`, { headers: authHeaders() }).then((r) => r.data);
export const adminAddBlackout = (date) => axios.post(`${API}/admin/blackouts`, { date }, { headers: authHeaders() }).then((r) => r.data);
export const adminRemoveBlackout = (date) => axios.delete(`${API}/admin/blackouts/${date}`, { headers: authHeaders() }).then((r) => r.data);

export const fetchImageBlob = (path) =>
  axios.get(`${API}/files/${path}`, { headers: authHeaders(), responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
